module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Button Details</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">\r\n        Aquire\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <input type=\"text\" name=\"buttonLabelAcquire\" style=\"width:70%;\" value=\"")
    ; __append(escapeFn( buttonLabelAcquire ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">\r\n        Remove\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <input type=\"text\" name=\"buttonLabelRemove\" style=\"width:70%;\" value=\"")
    ; __append(escapeFn( buttonLabelRemove ))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}